<div class="mt-4"></div>

@for (
  cat of specificationCategoryQuery.categories$ | async;
  track cat;
  let first = $first;
  let last = $last
) {
  <div class="w-full">
    <div class="flex justify-between">
      <div
        class="sticky top-0 flex w-full max-w-3xl items-center justify-between border bg-aux-gray-light px-5 py-3 text-xxs font-bold"
        [ngClass]="{
          'rounded-t-md': first,
        }"
      >
        <div>{{ cat.name }}</div>
        <aux-menu #cat_menu [disabled]="!!showForm()">
          <button
            class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
            role="menuitem"
            (click)="onShowForm(cat.id, cat); cat_menu.close()"
          >
            <aux-icon name="Plus" class="mr-2" />
            <span>Add new specification</span>
          </button>
        </aux-menu>
      </div>
      <button
        *auxAuthorize="{ sysAdminsOnly: true }"
        type="button"
        class="btn--primary"
        (click)="onSpecUploadClick()"
      >
        <aux-icon name="Upload" />
        <span class="ml-2">Upload Specification</span>
      </button>
    </div>

    <div class="max-w-3xl text-sm">
      @for (spec of cat.specifications; track spec) {
        <!--
      <div
        *ngIf="spec.input_type === 'INPUT_SINGLEVALUE' && (showForm | async) !== spec.id"
        class="border grid grid-cols-12 px-5 py-3"
       >
        <div class="col-span-9">
          {{ spec.name }}
        </div>
        <div class="col-span-3 flex justify-between items-center">
          <div>
            {{ spec.settings[0]?.setting_value }}
          </div>
          <aux-menu #single_menu>
            <button
              type="button"
              class="hover:bg-gray-100 hover:text-gray-900 text-gray-700 block px-4 py-2 text-sm w-full flex items-center rounded-md"
              (click)="onShowForm(spec.id, cat); single_menu.close()"
            >
              <span
                inlineSVG="edit.svg"
                class="w-5 h-5 mr-2 flex items-center justify-center"
              ></span>
              Edit specification
            </button>
            <button
              type="button"
              class="hover:bg-gray-100 hover:text-gray-900 text-gray-700 block px-4 py-2 text-sm w-full flex items-center rounded-md"
              (click)="onRemoveSpec(spec.id, cat); single_menu.close()"
            >
              <trash-solid-icon class="mr-2 w-5 h-5"></trash-solid-icon>
              Remove specification
            </button>
          </aux-menu>
        </div>
      </div>
       -->

        @if (spec.input_type === 'INPUT_MULTIVALUE' && showForm() !== spec.id) {
          <div class="grid grid-cols-12 border px-5 py-3 last:rounded-b-md">
            <div class="col-span-12 flex items-center justify-between font-medium">
              <div>{{ spec.name }}:</div>
              <aux-menu #multi_menu>
                <button
                  type="button"
                  class="block flex w-full items-center rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  (click)="onShowForm(spec.id, cat); multi_menu.close()"
                >
                  <aux-icon name="Pencil" class="text-aux-blue" />
                </button>
                <button
                  type="button"
                  class="block flex w-full items-center rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  (click)="onRemoveSpec(spec.id, cat); multi_menu.close()"
                >
                  <aux-icon name="Trash" class="text-aux-error" />
                </button>
              </aux-menu>
            </div>
            <hr class="col-span-12 my-2" />
            @for (setting of spec.settings; track setting) {
              <div class="col-span-9">{{ setting.setting_key || setting.setting_value }}</div>
              <div class="col-span-3 tabular-nums">
                {{ setting.setting_key ? setting.setting_value : '' }}
              </div>
            }
          </div>
        }

        @if (showForm() === spec.id) {
          <ng-container [ngTemplateOutlet]="form" />
        }
      }

      @if (showForm() === cat.id) {
        <ng-container [ngTemplateOutlet]="form" />
      }
      <ng-template #form>
        <form
          class="grid grid-cols-12 gap-5 border px-5 py-3"
          [formGroup]="fg"
          (ngSubmit)="onSaveForm(cat)"
        >
          @if (fg.get('specType')?.value === specTypesEnum.INPUT_MULTIVALUE) {
            <div class="col-span-4">
              <aux-input placeholder="Spec Name" formControlName="specName" auxFormError />
            </div>
            <div class="col-span-8"></div>
            @for (set of getSettingsControls(); track set; let i = $index) {
              <ng-container formArrayName="settings">
                <div
                  class="col-span-12 flex grid grid-cols-12 items-center gap-5"
                  [formGroupName]="i"
                >
                  <div class="col-span-4">
                    <aux-input
                      formControlName="label"
                      auxFormError
                      [placeholder]="'Set #' + (i + 1) + ' Name'"
                    />
                  </div>
                  <div class="col-span-4">
                    <aux-input
                      formControlName="value"
                      auxFormError
                      [placeholder]="'Set #' + (i + 1) + ' Value'"
                    />
                  </div>
                  <div class="col-span-4">
                    <ng-select
                      formControlName="type"
                      bindValue="value"
                      class="select select__big col-span-3 mt-0"
                      [clearable]="false"
                      [searchable]="false"
                      [items]="specSetTypes"
                      [placeholder]="'Set #' + (i + 1) + ' Type'"
                    />
                  </div>
                </div>
              </ng-container>
            }

            <div class="col-span-12 flex space-x-4">
              <button type="button" class="btn--hyperlink" (click)="onAddNewLine()">
                Add new line
              </button>
              @if (fg.get('settings')?.value.length > 1) {
                <button type="button" class="btn--hyperlink" (click)="onRemoveLastLine()">
                  Remove last line
                </button>
              }
            </div>
          }

          <div class="col-span-12 flex space-x-4">
            <button class="btn--primary w-32" type="submit">
              @if (loading$ | async) {
                <span class="spinner mr-3 h-6 w-6"></span>
              }
              <span>Save</span>
            </button>
            <button class="btn--tertiary" type="button" (click)="hideForm()">Cancel</button>
          </div>
        </form>
      </ng-template>
    </div>
  </div>
}
